import User from './../resource/User'

const API_DASHBOARD_ENTITY_TYPE     = 'enuHomePage'
const API_LEFT_MENU_ENTITY_TYPE     = 'enuLeftMenu'
const API_NOTIFICATIONS_ENTITY_TYPE = 'enuNotifMenu'
const API_PLUS_MENU_ENTITY_TYPE     = 'enuPlusMenu'
const API_PROFILE_MENU_ENTITY_TYPE  = 'enuProfileMenu'
const API_BASKET_MENU_ENTITY_TYPE   = 'EnuCartMenu'

export default new class UserBaseEntitiesLoader {

  constructor () {
    this._baseUserEntitiesPromise = null

    this.leftMenu      = null
    this.dashboard     = null
    this.notifications = null
    this.plusMenu      = null
    this.profileMenu   = null
    this.basketMenu    = null
  }

  reset () {
    this._baseUserEntitiesPromise = null

    this.leftMenu      = null
    this.dashboard     = null
    this.notifications = null
    this.plusMenu      = null
    this.profileMenu   = null
    this.basketMenu    = null
  }

  /**
   *
   * @param func
   */
  getBasketMenu (func) {
    if (!this._baseUserEntitiesPromise) {
      this._callUserBaseEntities()
    }

    Promise
      .all([this._baseUserEntitiesPromise])
      .then(() => {
        if (!this.basketMenu) {
          func(null)
          return
        }

        func(this.basketMenu)
      })
  }

  /**
   *
   * @param success
   * @param error
   */
  getUserLeftMenu (success, error) {
    if (!this._baseUserEntitiesPromise) {
      this._callUserBaseEntities(error)
    }

    Promise
      .all([this._baseUserEntitiesPromise])
      .then(() => {
        if (!this.leftMenu) {
          return
        }

        return User.getEntityDefinitions(
          { code: this.leftMenu }, success, error)
      })
  }

  /**
   *
   * @param success
   * @param error
   * @return {*}
   */
  getDashboardData (success, error) {
    if (!this._baseUserEntitiesPromise) {
      this._callUserBaseEntities(error)
    }

    Promise
      .all([this._baseUserEntitiesPromise])
      .then(() => {
        if (!this.dashboard) {
          this._setProperties()
        }

        return User.getEntityDefinitions(
          { code: this.dashboard }, success, error)
      })
  }

  /**
   *
   * @param success
   * @param error
   * @return {Promise<any>}
   */
  getNotificationsData (success, error) {
    if (!this._baseUserEntitiesPromise) {
      this._callUserBaseEntities(error)
    }

    return new Promise((resolve, reject) => {
      Promise
        .all([this._baseUserEntitiesPromise])
        .then(() => {
          if (!this.notifications) {
            return
          }

          let entityDefinitionPromise = User.getEntityDefinitions(
            { code: this.notifications }, success, error
          )

          Promise
            .all([entityDefinitionPromise])
            .then(() => {
              resolve()
            })
        })
    })
  }

  /**
   *
   * @param success
   * @param error
   * @return {*}
   */
  getProfileMenuData (success, error) {
    if (!this._baseUserEntitiesPromise) {
      this._callUserBaseEntities(error)
    }

    return new Promise((resolve, reject) => {
      Promise
        .all([this._baseUserEntitiesPromise])
        .then(() => {
          if (!this.profileMenu) {
            return
          }

          let entityDefinitionPromise = User.getEntityDefinitions(
            { code: this.profileMenu }, success, error
          )

          Promise
            .all([entityDefinitionPromise])
            .then(() => {
              resolve()
            })
        })
    })
  }

  /**
   *
   * @param success
   * @param error
   * @return {*}
   */
  getBasketMenuData (success, error) {
    if (!this._baseUserEntitiesPromise) {
      this._callUserBaseEntities(error)
    }

    return new Promise((resolve, reject) => {
      Promise
        .all([this._baseUserEntitiesPromise])
        .then(() => {
          if (!this.basketMenu) {
            return
          }

          let entityDefinitionPromise = User.getEntityDefinitions(
            { code: this.basketMenu }, success, error
          )

          Promise
            .all([entityDefinitionPromise])
            .then(() => {
              resolve()
            })
        })
    })
  }

  /**
   *
   * @param success
   * @param error
   * @return {*}
   */
  getPlusMenuData (success, error) {
    if (!this._baseUserEntitiesPromise) {
      this._callUserBaseEntities(error)
    }

    Promise
      .all([this._baseUserEntitiesPromise])
      .then(() => {
        if (!this.plusMenu) {
          return
        }

        return User.getEntityDefinitions(
          { code: this.plusMenu }, success, error)
      })
  }

  /**
   *
   * @param error
   * @private
   */
  _callUserBaseEntities (error) {
    let success = (response) => {
      this.userBaseEntitiesData = response.data
      this._setProperties()
    }

    this._baseUserEntitiesPromise = User.getUserBaseEntities(success, error)
  }

  /**
   *
   * @private
   */
  _setProperties () {
    for (let i = 0; i < this.userBaseEntitiesData.length; i++) {
      let definition = this.userBaseEntitiesData[i]

      switch (definition.EntityTypeName) {
        case API_DASHBOARD_ENTITY_TYPE:
          this.dashboard = definition.Code
          break

        case API_LEFT_MENU_ENTITY_TYPE:
          this.leftMenu = definition.Code
          break

        case API_NOTIFICATIONS_ENTITY_TYPE:
          this.notifications = definition.Code
          break

        case API_PLUS_MENU_ENTITY_TYPE:
          this.plusMenu = definition.Code
          break

        case API_PROFILE_MENU_ENTITY_TYPE:
          this.profileMenu = definition.Code
          break

        case API_BASKET_MENU_ENTITY_TYPE:
          this.basketMenu = definition.Code
          break
      }
    }
  }
}
